export default function ActivityTrendChart() {
  return (
    <div className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-gray-800">
        Activity Trend (24 Hours)
      </h2>

      <div className="mt-4 flex h-40 items-center justify-center rounded-xl border text-gray-400">
        Line Chart Placeholder
      </div>
    </div>
  );
}
